import api from './product';

export const getChatResponse = async (message, sessionId, language = 'zh') => {
  return api.post('/chat', { message, sessionId, language });
};

export default {
  getChatResponse
};